import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormToggleSwitchComplexBaseComponent } from '../base-complex/form-toggle-switch-complex-base.component';
import { ShFormToggleSwitchBaseComponent } from '../base-simple/form-toggle-switch-base.component';

@Component({
    selector: 'sh-form-toggle-switch',
    templateUrl: './form-toggle-switch.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgTemplateOutlet,
        ShActionItemComponent,
        ReactiveFormsModule,
        NgClass,
        AsyncPipe,
        ShFormToggleSwitchBaseComponent,
        ShFormToggleSwitchComplexBaseComponent
    ]
})
export class ShFormToggleSwitchComponent extends ShBaseFormComponent {
    @Input() description?: string;
}
